<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="产品类型："
              prop="productTypeId"
            >
              <a-select
                v-model="form.productTypeId"
                placeholder="请选择产品类型"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in productTypetions"
                  :key="item.productTypeId"
                >
                  {{ item.productTypeName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              label="产品名称:"
              prop="time"
            >
              <a-select
                v-model="form.productId"
                placeholder="请选择产品名称"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in productNames"
                  :key="item.productId"
                >
                  {{ item.productName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addBaseInfo"
          @exportResource="exportProducts"
        />
      </div>
    </div>

    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        @change="handleTableChange"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editProduct(record)"
            @delete="deleteRecord(record)"
          />
        </span>

        <template
          slot="taxRate"
          slot-scope="taxRate"
        >
          {{ taxRate + '%' }}
        </template>
      </a-table>
    </div>
    <EditAllproduct
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :product-typetions="productTypetions"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { queryProducts, deleteProduct, exportProducts } from '@/api/productManage.js'
import EditAllproduct from './EditAllproduct.vue'
import { pagination } from '@/constants/tableSetting'

import {
  queryAllProductTypes, queryAllProducts
} from '@/api/common.js'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'

const columns = [
  {
    title: '产品类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: '产品税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    scopedSlots: { customRender: 'taxRate' }
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '250px',
    scopedSlots: { customRender: 'actions' }
  }
]

const addActions = [{
  title: '添加产品',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  ghost: true,
  apis: ['@baseInfo/Export_Bases']

}]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditAllproduct
    // CheckChangeRecords
  },
  data () {
    return {
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      productNames: [],
      productTypetions: [],
      tableActions,
      addActions,
      headerActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      initRecords: null,
      dialogTitle: null,
      form: {
      },
      actionType: null
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    filterOption,
    inputKeydown,
    excelDown,
    async fetchSearchOptions () {
      await queryAllProductTypes().then((data) => {
        this.productTypetions = data
      })

      queryAllProducts().then((data) => {
        this.productNames = data
      })
    },
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryProducts({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        productTypeId: this.form.productTypeId,
        productId: this.form.productId
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    editProduct (record) {
      this.initData = record
      this.dialogTitle = '编辑产品'
      this.modalVisible = true
      this.actionType = '0'
    },
    addBaseInfo () {
      this.initData = {
        productTypeId: undefined,
        productName: undefined,
        taxRate: undefined,
        rateEdit: true
      }
      this.modalVisible = true
      this.dialogTitle = '添加产品'
      this.actionType = '1'
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          deleteProduct({
            productId: record.productId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
              this.fetchSearchOptions()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
      this.fetchSearchOptions()
    },
    async exportProducts () {
      await exportProducts({
        productTypeId: this.form.productTypeId,
        productId: this.form.productId
      }).then((data) => {
        this.excelDown(data, '全部产品')
      })
    }

  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}

/deep/.ant-table-body {
  width: 1200px;
  margin: auto;
}
</style>
